import { useContext, useEffect, useState } from 'react';
import './AppointmentForm.scss';
import Utils from '@/utils/util';
import {
  AppointmentData,
  AppointmentUserDetails,
  Business,
  Pet,
  PetWeightConfiguration,
} from '../types';
import { showNotification } from '@/utils/notificationUtils';
import PhoneInput from 'react-phone-input-2';
import { Form } from 'react-bootstrap';

import { ReactComponent as PetCat } from '@/assets/img/v2/pet-cat.svg';
import { ReactComponent as PetDog } from '@/assets/img/v2/pet-dog.svg';
import { ReactComponent as PlusIcon } from '@/assets/img/v2/plus-icon.svg';
import { ReactComponent as DeleteIcon } from '@/assets/img/v2/delete.red-icon.svg';

import { useGetPetSettings } from '../api/getPetSettings';
import { UserContext } from '@/components/Layout';
import { ReactMultiEmail } from '@/components/multiemail';
import { BackNav } from '@/components/BackNavigation/BackNavigation';
import { RangeDisplay } from './RangeDisplay';
import { PetCard } from './PetCard';
import { useGetServiceCost } from '../api/getCost';
import { DropDown } from '@/components/dropdown/DropDown';
import { addPet } from '../api/addPet';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
export type AppointmentFormProps = {
  appointmentData?: AppointmentData;
  business: Business;
  onSchedule: (appointmentData: AppointmentData) => void;
  back: () => void;
  isLoading: boolean;
};

export const AppointmentForm = ({
  appointmentData,
  business,
  onSchedule,
  back,
  isLoading,
}: AppointmentFormProps) => {
  const { t } = useTranslation();
  const userContext = useContext(UserContext);
  const petSettingsQuery = useGetPetSettings();
  const serviceCostMutation = useGetServiceCost();
  const [breedList, setBreedList] = useState<any[]>();
  const [petSizeList, setPetSizeList] = useState<any[]>();
  const [newPets, setNewPets] = useState<Pet[]>([]);
  const [selectedNewPetIndex, setSelectedNewPetIndex] = useState<number>(-1);
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  

  const [pet, setPet] = useState<Pet>({
    name: '',
    breed: Utils.BREED_UNSPECIFIED,
    petType: Utils.getPetTypes(appointmentData?.business?.offerings?.petTypes),
    petSize: undefined,
    petAge:''
  });
  const [userAppointmentData, setUserAppointmentData] = useState<AppointmentUserDetails>({
    name: '',
    email: '',
    phone: '+1',
    receiveUpdates: false,
    altEmails: [],
  });
  useEffect(() => {
    Utils.scrollToTop();
    if (appointmentData?.userData) {
      setUserAppointmentData(appointmentData?.userData);
      if (appointmentData.selectedServiceType !== Utils.SERVICE_TYPES.GROOMING) {
        setNewPets(appointmentData.petProfiles ? appointmentData.petProfiles : []);
      } else {
        setPet(
          appointmentData.petProfiles && appointmentData.petProfiles.length > 0
            ? appointmentData.petProfiles[0]
            : {
                name: '',
                breed: Utils.BREED_UNSPECIFIED,
                petType: Utils.getPetTypes(appointmentData?.business?.offerings?.petTypes),
                petSize: undefined,
                petAge: ''
              }
        );
      }
    }
  }, []);

  useEffect(() => {
    if (petSettingsQuery.data) {
      setBreedList(petSettingsQuery?.data?.breed_list.map((t: string) => ({ value: t, label: t })));
      formatPetSize(petSettingsQuery?.data.pet_size_defaults);
    }
  }, [petSettingsQuery.data]);

  const backToPreviousPage = () => {
    back();
  };

  const formatPetSize = (petWeightConfig: PetWeightConfiguration) => {
    const pwCon: any[] = [];
    if (petWeightConfig) {
      for (const [key, value] of Object.entries(petWeightConfig)) {
        pwCon.push({ value: key, label: value.name });
      }
    }
    setPetSizeList(pwCon);
  };
  const next = async () => {
    if (appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.GROOMING) {
      const isFormValid = validate();
      if (isFormValid) {
        if (appointmentData) {
          appointmentData.userData = userAppointmentData;
          appointmentData.petProfiles = pet.name ? [pet] : [];
          onSchedule({ ...appointmentData });
        }
      }
    } else {
      let request = undefined;
      const addedPets = [...newPets];
      const noOfPetAllowed = appointmentData?.noOfPets ? appointmentData?.noOfPets : 0;
      if (newPets.length < noOfPetAllowed && pet && validatePet(false)) {
        addedPets.push(pet);
      }
      if (appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.DAY_CARE) {
        request = {
          duration: appointmentData?.duration,
          startTime: appointmentData?.slot?.start,
          petDetails: addedPets,
          petCount: appointmentData?.noOfPets,
        };
      } else {
        request = {
          startDate: moment(appointmentData?.startDate).format('YYYY-MM-DD'),
          endDate: moment(appointmentData?.endDate).format('YYYY-MM-DD'),
          petDetails: addedPets,
          petCount: appointmentData?.noOfPets,
        };
      }
      const res = await serviceCostMutation.mutateAsync({
        data: request,
        serviceType: appointmentData?.selectedServiceType,
      });
      if (appointmentData && res) {
        appointmentData.userData = userAppointmentData;
        appointmentData.petProfiles = addedPets;
        appointmentData.cost = res;
        onSchedule({ ...appointmentData });
      }
      // if (newPets.length > 0) {
      // } else {
      //   showNotification({
      //     type: 'info',
      //     title: 'Please add one or more pets to book room',
      //   });
      // }
    }
  };
  const validate = () => {
    const { name, email, phone } = userAppointmentData;
    const { name: petName, petType, breed, petSize } = pet;
    let errorMessage;
    if (!name) {
      errorMessage = t('Please enter valid full name');
    } else if (!email || email.trim().length < 1 || !Utils.isValidEmail(email)) {
      errorMessage = t('please enter valid email');
    } else if (!phone || phone.trim().length < 1) {
      errorMessage = t('Please enter valid phone number');
    } else if(phone) {
      if(!isPhoneValid) {
        errorMessage = t('Please enter valid phone number');
      }
    } 

    // if (business?.registrationRequired || business?.collectPetInfo) {
    //   if (!petName || petName.trim().length < 1) {
    //     errorMessage = 'Please enter valid pet name';
    //   } else if (!petType || petType.trim().length < 1) {
    //     errorMessage = 'Please select pet type';
    //   } else if (!breed || breed.trim().length < 1) {
    //     errorMessage = 'Please select valid pet breed';
    //   } else if (!petSize || petSize.trim().length < 1) {
    //     errorMessage = 'Please select pet size';
    //   }
    // }

    if (errorMessage) {
      showNotification({
        type: 'info',
        title: errorMessage,
      });
      return false;
    }
    return true;
  };

  const validatePet = (showAlert = true) => {
    const { name, petType, breed, petSize } = pet;
    let errorMessage;
    if (
      appointmentData?.selectedLocation?.registrationRequired ||
      appointmentData?.selectedLocation?.collectPetInfo
    ) {
      if (!name || name.trim().length < 1) {
        errorMessage = 'Please enter valid pet name';
      } else if (!petType || petType.trim().length < 1) {
        errorMessage = 'Please select pet type';
      } else if (!breed || breed.trim().length < 1) {
        errorMessage = 'Please select valid pet breed';
      } else if (!petSize || petSize.trim().length < 1) {
        errorMessage = 'Please select pet size';
      }
    }

    if (errorMessage) {
      showAlert &&
        showNotification({
          type: 'info',
          title: errorMessage,
        });
      return false;
    }
    return true;
  };

  const onPhoneFieldChange = (
    value: string ,
    country: any
  ) => {
    if(value === country.dialCode)  {
      setIsPhoneValid(false);
    } else {
      const data: any = userAppointmentData;
      if (userAppointmentData) {
        data['phone'] = value;
      }
      setIsPhoneValid(true);
      setUserAppointmentData({ ...data });
    }
  }
  const onFormValueChange = (formFieldName: string, value: string) => {
    if (userAppointmentData) {
      pet[formFieldName as keyof typeof pet] = value;
    }
    setPet({ ...pet });
  };

  const onFormUserValueChange = (formFieldName: string, value: string | boolean | string[]) => {
    const data: any = userAppointmentData;
    if (userAppointmentData) {
      data[formFieldName] = value;
    }
    setUserAppointmentData({ ...data });
  };
  const advanceBooking =
    appointmentData?.selectedLocation?.advBookingPercentage &&
    parseFloat(appointmentData?.selectedLocation?.advBookingPercentage) > 0
      ? parseFloat(appointmentData?.selectedLocation?.advBookingPercentage)
      : appointmentData?.selectedLocation?.advBookingAmount &&
        parseFloat(appointmentData?.selectedLocation?.advBookingAmount) > 0
      ? parseInt(appointmentData?.selectedLocation?.advBookingAmount)
      : 0;

  const onAddPet = () => {
    const noOfPetAllowed = appointmentData?.noOfPets ? appointmentData?.noOfPets : 0;
    if (newPets.length < noOfPetAllowed) {
      const isValid = validatePet();
      if (isValid) {
        newPets?.push(pet);
        setNewPets([...newPets]);
        setPet({
          name: '',
          breed: Utils.BREED_UNSPECIFIED,
          petType: Utils.getPetTypes(appointmentData?.business?.offerings?.petTypes),
          petSize: undefined,
          petAge: ''
        });
      }
    } else {
      showNotification({
        type: 'info',
        title: 'You cannot select more pet than request count for booking.',
      });
      setPet({
        name: '',
        breed: Utils.BREED_UNSPECIFIED,
        petType: Utils.getPetTypes(appointmentData?.business?.offerings?.petTypes),
        petSize: undefined,
        petAge: ''
      });
    }
  };
  const editNewPetDetails = (index: number) => {
    setSelectedNewPetIndex(index);
    setPet({ ...newPets[index] });
  };
  const deleteNewPet = () => {
    newPets.splice(selectedNewPetIndex, 1);
    setNewPets([...newPets]);
    setSelectedNewPetIndex(-1);
    setPet({
      name: '',
      breed: Utils.BREED_UNSPECIFIED,
      petType: Utils.getPetTypes(appointmentData?.business?.offerings?.petTypes),
      petSize: undefined,
      petAge: ''
    });
  };
  const onUpdatePet = () => {
    const isValid = validatePet();
    if (isValid) {
      newPets.splice(selectedNewPetIndex, 1, pet);
      setNewPets([...newPets]);
      setSelectedNewPetIndex(-1);
      setPet({
        name: '',
        breed: Utils.BREED_UNSPECIFIED,
        petType: Utils.getPetTypes(appointmentData?.business?.offerings?.petTypes),
        petSize: undefined,
        petAge: ''
      });
    }
  };
  const defaultPetType = Utils.getPetTypes(appointmentData?.business?.offerings?.petTypes);
  return (
    <div className={`appointment-form ${appointmentData?.selectedServiceType}`}>
      <BackNav onClick={backToPreviousPage} />
      <div className="petsked-form">
        {appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.BOARDING && (
          <RangeDisplay
            startDate={appointmentData?.startDate}
            endDate={appointmentData?.endDate}
            business={business}
            showTime={true}
            appointmentData={appointmentData}
          />
        )}
        {(appointmentData?.selectedLocation?.registrationRequired ||
          (appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.GROOMING &&
            appointmentData?.selectedLocation?.collectPetInfo) ||
          appointmentData?.selectedServiceType !== Utils.SERVICE_TYPES.GROOMING) && (
          <>
            <label className={!userContext?.isLandscape ? `small` : ''}>Pet Details</label>
            {newPets && newPets.length > 0 && (
              <div className="new-pet-list">
                {newPets.map((item: Pet, index: number) => {
                  return (
                    <PetCard
                      key={`new-pet-${index}`}
                      data={item}
                      showDeleteOption={true}
                      isSelected={selectedNewPetIndex === index ? true : false}
                      onChange={(data: Pet) => {
                        editNewPetDetails(index);
                      }}
                      onDelete={() => deleteNewPet()}
                    />
                  );
                })}
              </div>
            )}
            <div className="split pet-type-split mb-15">
              {(!defaultPetType || defaultPetType.toLowerCase() === 'dog') && (
                <div
                  className={`pet-type dog ${
                    pet?.petType?.toLowerCase() === 'dog' ? 'selected' : ''
                  }`}
                  onClick={() => onFormValueChange('petType', 'dog')}
                >
                  <PetDog className="dog" />
                  <div className="">
                    <div className="title">{t('Dog')}</div>
                    {/* <div className="desc">
                    {userContext?.isLandscape ? 'I have a ' : ''} pet doggie
                  </div> */}
                  </div>
                </div>
              )}
              {(!defaultPetType || defaultPetType.toLowerCase() === 'cat') && (
                <div
                  className={`pet-type cat ${
                    pet?.petType?.toLowerCase() === 'cat' ? 'selected' : ''
                  }`}
                  onClick={() => onFormValueChange('petType', 'cat')}
                >
                  <PetCat className="cat" />
                  <div className="">
                    <div className="title">{t('Cat')}</div>
                    {/* <div className="desc">
                    {userContext?.isLandscape ? 'I have a ' : ''} cute kitty
                  </div> */}
                  </div>
                </div>
              )}
            </div>
            <div className="split full pet mb-15">
              <input
                type="text"
                value={pet?.name}
                placeholder="Pet Name"
                onInput={(e: any) => onFormValueChange('name', e.target?.value)}
              />
              <DropDown
                placeholder="Select Breed"
                selectedValue={pet?.breed}
                data={breedList ? breedList : []}
                onSelect={(value: any) => {
                  onFormValueChange('breed', value);
                }}
                onDismiss={() => {}}
                enableSearch={true}
              />
            </div>
            <div className="split full pet">
              <input
                type="text"
                value={pet?.petAge}
                placeholder="Pet Age"
                maxLength={25}
                onInput={(e: any) => onFormValueChange('petAge', e.target?.value)}
              />
              <DropDown
                placeholder="Select pet size"
                selectedValue={pet?.petSize}
                data={petSizeList ? petSizeList : []}
                onSelect={(value: any) => {
                  onFormValueChange('petSize', value);
                }}
                onDismiss={() => {}}
                enableSearch={false}
              />
            </div>
            <div className="action-pet-form">
              {console.log('selectedNewPetIndex ---- > ', selectedNewPetIndex)}
              {selectedNewPetIndex >= 0 ? (
                <>
                  <button
                    className="petsked-button button-no-bg icon"
                    onClick={() => deleteNewPet()}
                  >
                    <DeleteIcon />
                    <span>Remove pet</span>
                  </button>
                  <button
                    className="petsked-button button-light icon"
                    onClick={() => onUpdatePet()}
                  >
                    <span>Update detail</span>
                  </button>{' '}
                </>
              ) : (
                appointmentData?.selectedServiceType !== Utils.SERVICE_TYPES.GROOMING && (
                  <>
                    <span></span>
                    <button className="petsked-button button-light icon" onClick={() => onAddPet()}>
                      <PlusIcon />
                      <span>Add another pet</span>
                    </button>
                  </>
                )
              )}
            </div>
          </>
        )}
        {userContext?.isLandscape &&
          (appointmentData?.selectedLocation?.registrationRequired ||
            appointmentData?.selectedLocation?.collectPetInfo) && (
            <>
              <hr />
            </>
          )}
        <label>
          {userContext?.isLandscape ? 'Personal Information' : 'Personal and Pet details'}
        </label>
        {!userContext?.isLandscape && (
          <>
            <label className="small">Personal Information</label>
          </>
        )}
        <input
          className="fn"
          type="text"
          value={userAppointmentData?.name}
          placeholder="Full name"
          onInput={(e: any) => onFormUserValueChange('name', e.target?.value)}
        />
        <div className="split full personal">
          <input
            type="email"
            value={userAppointmentData?.email}
            placeholder="Email address"
            onInput={(e: any) => onFormUserValueChange('email', e.target?.value)}
          />
          <PhoneInput
            country={'us'}
            value={userAppointmentData?.phone}
            placeholder="Phone number"
            onChange={onPhoneFieldChange}
            countryCodeEditable={false}
          />
        </div>
        <div>
          <ReactMultiEmail
            placeholder="Additional Emails"
            emails={userAppointmentData?.altEmails}
            onChange={(_emails: string[]) => {
              onFormUserValueChange('altEmails', _emails);
            }}
            autoFocus={false}
            getLabel={(email: any, index: number, removeEmail: any) => {
              return (
                <div data-tag key={index}>
                  <div data-tag-item>{email}</div>
                  <span data-tag-handle onClick={() => removeEmail(index)}>
                    ×
                  </span>
                </div>
              );
            }}
          />
        </div>
        {userContext?.isLandscape && (
          <>
            <hr />
          </>
        )}
        {userContext?.isLandscape && (
          <div className="form-footer">
            {' '}
            <div className="terms-container">
              <Form.Check
                type="checkbox"
                className="terms-checkbox"
                name="service"
                id="receive-updates"
                onChange={(e) => onFormUserValueChange('receiveUpdates', e.target?.checked)}
              />{' '}
              <label htmlFor="receive-updates">
                {t('Yes, I would like to receive updates and reminders regarding my booking.')}
              </label>
            </div>
          </div>
        )}
      </div>
      <div className="form-footer">
        {' '}
        {!userContext?.isLandscape && (
          <div className="terms-container">
            <Form.Check
              type="checkbox"
              className="terms-checkbox"
              name="service"
              id="receive-updates"
              onChange={(e) => onFormUserValueChange('receiveUpdates', e.target?.checked)}
            />{' '}
            <label htmlFor="receive-updates">
              {t('Yes, I would like to receive updates and reminders regarding my booking.')}
            </label>
          </div>
        )}
        <div className="action">
          {/* <button
            className="petsked-button button-dark"
            onClick={() => backToPreviousPage()}
            disabled={bookAppointmentMutation.isLoading}
          >
            Back
          </button> */}
          <button
            className="petsked-button button-dark"
            onClick={() => next()}
            disabled={isLoading}
          >
            {isLoading
              ? 'Scheduling...'
              : advanceBooking && appointmentData?.selectedLocation?.reservationType != 'REQUEST'
              ? 'Continue'
              : 'Complete Booking'}
          </button>
          {!(advanceBooking && appointmentData?.selectedLocation?.reservationType != 'REQUEST') &&
            appointmentData?.business?.termsOfService &&
            appointmentData?.business?.termsOfService.length > 0 && (
              <p className="terms-and-condition">
                {t('By clicking')} {`${t('Complete Booking')}`} {t('you agree to the')}{' '}
                <a
                  rel="noreferrer"
                  href={window.location.origin + '/' + appointmentData?.business?.slug + '/terms'}
                  target="_blank"
                >
                  {t('Terms of Use')}
                </a>{' '}
                {t('of the provider.')}
              </p>
            )}
        </div>
      </div>
    </div>
  );
};
AppointmentForm.displayName = 'BusinessMeeting';
